import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * this function will take a datestring and format the dates in December 8, 2023 02:54:22
 * @param dateString
 * @returns the formatted date like December 8, 2023 02:54:22
 */
export function formatDate(dateString) {
  const date = new Date(dateString);

  // Array of month names
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Get date components
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  // Create formatted string
  return `${month} ${day}, ${year} ${hours}:${minutes}:${seconds}`;
}

export function getTagsValus(data) {
  let Tags: any = [];
  function getTagsRecursive(data) {
    data.forEach((item) => {
      if (item && item["sidebarProps"]["displayText"]) Tags.push(item);

      if (item.children && item.children.length > 0) {
        getTagsRecursive(item.children);
      }
    });
  }
  getTagsRecursive(data);
  return Tags;
}

export function getALLTag(data) {
  let tag = [];
  data.forEach((item) => {
    tag = extractDisplayText(item);
  });
  return tag;
}

export function extractDisplayText(obj: any, tags: any = []) {
  if (obj.sidebarProps?.displayText) {
    tags.push(obj.sidebarProps.displayText);
  }
  if (obj.children) {
    obj.children.forEach((child) => extractDisplayText(child, tags));
  }
  return tags;
}

export function filterSubModels(modelData, results:any = [], pathParameter) {
  // console.log("ExpandedSideBarArea filterSubModels called with pathParameter:", pathParameter);
  // console.log("ExpandedSideBarArea filterSubModels modelData:", modelData);

  for (const item of modelData) {
    // console.log("pathParameter item:", item);
    // console.log("pathParameter item state:", item.path);
    // console.log("pathParameter.toLowerCase() in item.path.toLowerCase(): ", pathParameter.toLowerCase(), item.path.toLowerCase());
   
    if (item.path != "") {
      if (item.path.toLowerCase().includes(pathParameter.toLowerCase())) {
        results.push(item);
      }
    }

    if (Array.isArray(item.children)) {
      filterSubModels(item.children, results,pathParameter);
    }
  }

  // console.log("ExpandedSideBarArea filterSubModels results:", results);
  return results;
}


